import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

class AsyncComponent extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      Component: null,
    }
  }

  componentDidMount() {
    if (!this.state.Component) {
      this.props.moduleProvider().then(({ Component }) => {
        this.setState({ Component });
      });
    }
  }

  render() {
    const { Component } = this.state;
    const { componentProps } = this.props;

    return (
      <Fragment>
        {Component ? <Component {...{ ...componentProps }} /> : <Fragment />}
      </Fragment>
    );
  }
}

AsyncComponent.propTypes = {
  moduleProvider: PropTypes.func.isRequired,
  componentProps: PropTypes.object,
}

AsyncComponent.defaultProps = {
  componentProps: {},
}

export default AsyncComponent;